import { Button } from '@aimsos/ui';

/**
 * Dashboards domain buttons: label at 0.75rem (`text-xs`) app-wide.
 * Forwards other props to {@link @aimsos/ui#Button}.
 */
const DashboardButton = ({ className = '', ...props }) => (
  <Button {...props} className={[className, 'text-xs'].filter(Boolean).join(' ')} />
);

export default DashboardButton;
